export interface ComparisonRow {
  category: string;
  bestItem: string;
  avgPrice: string;
  rating: number;
  shipping: string;
  recommendation: string;
}

export const comparisonData: ComparisonRow[] = [
  {
    category: 'Shoes',
    bestItem: 'ACBuy Top Sneakers',
    avgPrice: '$45 – $80',
    rating: 4.8,
    shipping: '7 – 12 days',
    recommendation: 'Highly Recommended',
  },
  {
    category: 'Hoodies / Sweaters',
    bestItem: 'ACBuy Premium Hoodie',
    avgPrice: '$25 – $55',
    rating: 4.7,
    shipping: '6 – 10 days',
    recommendation: 'Best Value',
  },
  {
    category: 'T-Shirts',
    bestItem: 'ACBuy Streetwear Tee',
    avgPrice: '$12 – $30',
    rating: 4.6,
    shipping: '5 – 9 days',
    recommendation: 'Popular Pick',
  },
  {
    category: 'Jackets',
    bestItem: 'ACBuy Winter Parka',
    avgPrice: '$55 – $120',
    rating: 4.7,
    shipping: '8 – 14 days',
    recommendation: 'Top Quality',
  },
  {
    category: 'Pants / Shorts',
    bestItem: 'ACBuy Cargo Pants',
    avgPrice: '$20 – $50',
    rating: 4.5,
    shipping: '6 – 11 days',
    recommendation: 'Solid Choice',
  },
  {
    category: 'Headwear',
    bestItem: 'ACBuy Classic Cap',
    avgPrice: '$8 – $22',
    rating: 4.4,
    shipping: '5 – 8 days',
    recommendation: 'Budget Win',
  },
  {
    category: 'Sets',
    bestItem: 'ACBuy Matching Set',
    avgPrice: '$40 – $90',
    rating: 4.6,
    shipping: '7 – 13 days',
    recommendation: 'Great Deal',
  },
  {
    category: 'Jersey',
    bestItem: 'ACBuy Pro Jersey',
    avgPrice: '$30 – $65',
    rating: 4.5,
    shipping: '6 – 12 days',
    recommendation: 'Fan Favorite',
  },
  {
    category: 'Accessories',
    bestItem: 'ACBuy Watch Bundle',
    avgPrice: '$15 – $45',
    rating: 4.3,
    shipping: '5 – 10 days',
    recommendation: 'Worth It',
  },
  {
    category: 'Bags',
    bestItem: 'ACBuy Urban Backpack',
    avgPrice: '$25 – $60',
    rating: 4.6,
    shipping: '7 – 14 days',
    recommendation: 'Highly Recommended',
  },
];

export interface CompetitorRow {
  platform: string;
  dataQuality: string;
  priceAccuracy: string;
  updateSpeed: string;
  trustScore: string;
}

export const competitorData: CompetitorRow[] = [
  {
    platform: 'ACBuy Spreadsheet',
    dataQuality: 'High',
    priceAccuracy: 'High',
    updateSpeed: 'Daily',
    trustScore: '9.5/10',
  },
  {
    platform: 'PandaBuy List',
    dataQuality: 'Medium',
    priceAccuracy: 'Medium',
    updateSpeed: 'Weekly',
    trustScore: '7.0/10',
  },
  {
    platform: 'Taobao Agents',
    dataQuality: 'Medium',
    priceAccuracy: 'Low',
    updateSpeed: 'Slow',
    trustScore: '6.5/10',
  },
  {
    platform: 'Generic Spreadsheets',
    dataQuality: 'Low',
    priceAccuracy: 'Low',
    updateSpeed: 'Irregular',
    trustScore: '5.0/10',
  },
];